import React from 'react';
import { DefaultconversionListFormData } from '.';
import usePricingContext from 'contexts/pricing.context';
import { Input } from '@cokitchen/cokitchen-components';

const AddConversionListDetails = () => {
  const { conversionListFormData, setConversionListFormData } = usePricingContext();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | { target: { name: string; value: string } },
    index: number
  ) => {
    const { name, value } = e.target;
    setConversionListFormData(
      conversionListFormData.map((itm, i) => (i === index ? { ...itm, [name]: value } : itm))
    );
  };

  const addVendor = () => {
    setConversionListFormData([...conversionListFormData, { ...DefaultconversionListFormData }]);
  };
  const removeVendor = (index: number) => {
    setConversionListFormData(conversionListFormData.filter((item, i) => index !== i));
  };

  return (
    <div>
      <h3 className='text-xl font-semibold'>Provide excel meal details </h3>
      {conversionListFormData?.map((item, index) => (
        <div key={index}>
          <div className='flex flex-col gap-6 w-[100%] mt-8'>
            <Input
              design='bordered'
              name='secton_name'
              label='Brand'
              value={item.secton_name}
              onChange={(e) => handleChange(e, index)}
              placeholder='E.g Green gourmet'
            />

            <Input
              design='bordered'
              name='name'
              label='Name of meal'
              value={item.name}
              onChange={(e) => handleChange(e, index)}
              placeholder='E.g Ceaser Salad'
            />
          </div>
          <div className='flex justify-end'>
            {index >= 1 && (
              <button
                onClick={() => removeVendor(index)}
                className='text-[#E60A2B] mt-2 font-medium text-sm '>
                - Remove excel meal
              </button>
            )}
          </div>
        </div>
      ))}
      <button onClick={addVendor} className='text-[#0080E5] mt-2 font-medium text-sm'>
        + Add excel meal
      </button>
    </div>
  );
};

export default AddConversionListDetails;
